import { color, duration, size, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Link from "../../Link";
import { TextStyledComponents } from "../../Text";
export const TextLink = styled(Link) `
  && {
    color: ${color.font.link.default};
    cursor: pointer;
    transition: color ${duration.animation.moderate}ms;
    font-weight: bold;
    font-size: ${size.font.link.default};
    position: relative;
    width: fit-content;
  }

  ${TextStyledComponents.TextHolder} &,
  h1 > &,
  h2 > &,
  h3 > & {
    font-size: inherit;
    font-weight: normal;
  }

  &:hover {
    color: ${color.font.link.hover};
  }

  &.inverse {
    color: ${color.font.link.inverse.default};

    &:hover {
      color: ${color.base.hostingBlue.$50};
    }

    &:active {
      color: ${color.base.hostingBlue.$50};
    }

    &&.disabled,
    &&.disabled:hover {
      color: ${color.base.grey.$300};
    }
  }

  &.isActive,
  &:active {
    color: ${color.font.link.active};
  }

  &&.disabled,
  &&.disabled:hover {
    color: ${color.font.link.disabled};
    cursor: not-allowed;
  }

  &.destructive {
    color: ${color.font.destructiveLink.default};

    &:hover {
      color: ${color.font.destructiveLink.hover};
    }

    &:active {
      color: ${color.font.destructiveLink.active};
    }

    &&.disabled,
    &&.disabled:hover {
      color: ${color.font.destructiveLink.disabled};
    }
  }

  &.disabled,
  &.disabled:hover {
    color: ${color.font.text.disabled};
    cursor: not-allowed;
  }

  &.focus,
  &:focus-visible {
    position: relative;
    outline: none;

    &:before {
      content: "";
      position: absolute;
      left: -${spacing.base.xs};
      right: -${spacing.base.xs};
      top: 0;
      bottom: 0;
      border: ${size.border.base.outline} solid ${color.border.input.focused};
      border-radius: ${size.borderRadius};
    }
  }
`;
export default TextLink;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dExpbmsuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UZXh0TGluay9zdHlsZWQvVGV4dExpbmsudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLEtBQUssRUFDTCxRQUFRLEVBQ1IsSUFBSSxFQUNKLE9BQU8sR0FDUixNQUFNLGdEQUFnRCxDQUFDO0FBQ3hELE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sSUFBSSxNQUFNLFlBQVksQ0FBQztBQUM5QixPQUFPLEVBQUUsb0JBQW9CLEVBQUUsTUFBTSxZQUFZLENBQUM7QUFFbEQsTUFBTSxDQUFDLE1BQU0sUUFBUSxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQTs7YUFFdkIsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTzs7d0JBRVosUUFBUSxDQUFDLFNBQVMsQ0FBQyxRQUFROztpQkFFbEMsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTzs7Ozs7SUFLbkMsb0JBQW9CLENBQUMsVUFBVTs7Ozs7Ozs7O2FBU3RCLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUs7Ozs7YUFJckIsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLE9BQU87OztlQUc3QixLQUFLLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxHQUFHOzs7O2VBSTFCLEtBQUssQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLEdBQUc7Ozs7O2VBSzFCLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUk7Ozs7OzthQU10QixLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNOzs7OzthQUt0QixLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFROzs7OzthQUt4QixLQUFLLENBQUMsSUFBSSxDQUFDLGVBQWUsQ0FBQyxPQUFPOzs7ZUFHaEMsS0FBSyxDQUFDLElBQUksQ0FBQyxlQUFlLENBQUMsS0FBSzs7OztlQUloQyxLQUFLLENBQUMsSUFBSSxDQUFDLGVBQWUsQ0FBQyxNQUFNOzs7OztlQUtqQyxLQUFLLENBQUMsSUFBSSxDQUFDLGVBQWUsQ0FBQyxRQUFROzs7Ozs7YUFNckMsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUTs7Ozs7Ozs7Ozs7O2VBWXRCLE9BQU8sQ0FBQyxJQUFJLENBQUMsRUFBRTtnQkFDZCxPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7OztnQkFHZixJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxPQUFPLFVBQVUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsT0FBTzt1QkFDckQsSUFBSSxDQUFDLFlBQVk7OztDQUd2QyxDQUFDO0FBRUYsZUFBZSxRQUFRLENBQUMifQ==